const LIST_ROWS = 5;

export default LIST_ROWS;
